import { create } from 'src/store/createStore';
import { DriverResource } from 'src/types/drivers';
import { CostCentre } from 'src/types/costCentre';
import { persist, createJSONStorage } from 'zustand/middleware';
import { DriverPeriodResource } from 'src/pages/deals/types/drivers';
import { getEmployees } from 'src/api/drivers';
import { AxiosResponse } from 'axios';
import { getTerminus } from 'src/api/costCentre';

interface CommonDataState {
  driverResource: DriverResource[];
  driverResourceFilters: DriverResource[];
  terminus: CostCentre[];
  dealPeriods: DriverPeriodResource[];
  setDriverResourceFilters: (data: DriverResource[]) => void;
  setDriverResource: (data: DriverResource[]) => void;
  getDriverApi: () => Promise<AxiosResponse<DriverResource[]>>;
  setTerminus: (data: CostCentre[]) => void;
  getTerminusApi: () => Promise<AxiosResponse<CostCentre[]>>;
  setDealPeriods: (data: DriverPeriodResource[]) => void;
  reset: () => void;
}

export const commonDataStore = create<CommonDataState>()(
  persist(
    (set) => ({
      driverResource: [],
      driverResourceFilters: [],
      terminus: [],
      dealPeriods: [],
      setDriverResourceFilters: (data: DriverResource[]) => {
        set({ driverResourceFilters: data });
      },
      setDriverResource: (data: DriverResource[]) => {
        set({ driverResource: data });
      },
      getDriverApi: async () => {
        const response = await getEmployees(false);
        if (response?.data) {
          const driver = response.data.map((d) => ({
            ...d,
            rut: `${d.id.slice(0, -1)}-${d.id.slice(-1)}`,
          }));
          set({ driverResource: driver });
          set({ driverResourceFilters: driver });
        }
        if (response?.data.length === 0) {
          set({ driverResource: [] });
          set({ driverResourceFilters: [] });
        }
        return response;
      },
      setTerminus: (data: CostCentre[]) => {
        set({ terminus: data });
      },
      getTerminusApi: async () => {
        const response = await getTerminus();
        if (response?.data) {
          const terminus = response.data;
          set({ terminus });
        }
        if (response?.data.length === 0) {
          set({ terminus: [] });
        }
        return response;
      },
      setDealPeriods: (data: DriverPeriodResource[]) => {
        set({ dealPeriods: data });
      },
      reset: () => {
        set({
          driverResource: [],
          terminus: [],
        });
      },
    }),
    {
      name: 'common-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
